module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")]), _vm._v(" CHAPTER 4 "), _c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")])])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "COT"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he girl, whose name was Kit, stood up with a forwardness that startled him. She must have thought he needed rescue. He didn’t. He filed all such conversations in his mind under "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Indya")]), _vm._v(": press button one and you got reams of stuff from the ex-colonials about the railways and the ungratefulness; or the rhapsodies about the sunsets! the spirituality! the smells! and not forgetting, ah! the cow dust and the fires, the spices! Add in the rifle dust and you had Parfum de Partition.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In the hallway, she picked up his briefcase. “I can take this,” she said, leaving the heavier ones for him. He almost blushed, conscious of the packet of French letters scattered amongst the few shirts, his cigarettes, the Catholic missal his mother had packed with the note inside saying, “Don’t forget your prayers.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The condoms were standard issue for red-blooded medical students, but for him an invitation to a dance full of complications.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Walking upstairs in the glow of the lamplight, he did his best to ignore the slim ankles, the straight line of her stocking, the silk sway of her dark hair: women were off limits now that he was going home. To make this absolutely clear to himself, he’d gone back to Downside the week before and spoken in great confusion to his moral tutor, Father Damian: a dear, fat old man with a great sense of humor, who had made his life so much better during his four years there.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Over a glass of port in the book-lined study, he’d started with ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("the smaller sin first: he was too addicted to going to the cinema, and it was time spent away from his PhD. “Well.” Father Damian had taken a sip, bunched his eyebrows judiciously. “Exactly how many hours a week do you donate to this pastime?”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sometimes a whole afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And what proportion of the week do you devote to your studies?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Anto thought about this. “It depends if I have lectures or tutorials.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Include both in the sum.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe sixty hours. I have to get my doctorate before I go home.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think God may forgive you for a little time off.” Father ­Damian’s smile was dry and fond. “And working too hard is another sin, you know. But I hope,” the monk added with a sly look, “you have the intellectual rigor to watch Eisenstein, and not a lot of old tosh. I do worry about your cultural bearings; remember our night at the opera?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Anto had never been allowed to forget it: the excruciating performance of "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Madame Butterfly")]), _vm._v(" during his first term at the school. His eardrums so punctured by the foreign screeching, he’d sat, hands over his ears, wanting to howl like a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But films were different. A drug, a way of forgetting and finding yourself inside the big faces on the screen. He’d sat in the dark avidly noticing the details: the manners of the handsome men up there, their ways of smoking, of greeting women, of leaving rooms, and later, this close attention had led to him becoming a clever mimic who could make other boys laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Towards the end of this pleasant meeting, Father Damian wondered if there was something else troubling him, and if there was, he might take advantage of his time here and go to confession. Half an hour later, he’d knelt in the old school chapel and, breathing in the smells of incense and old velvet, blurted out his confusion and pain.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("During the past two years, he’d slept with two women, out of ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("lust, not love. One of them, a student nurse at Barts, a nice girl, fair-haired, ethereal-looking, had fallen in love with him and been badly hurt when he couldn’t return the feeling.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("The other, a worldly WAAF, boyfriend in France, had hurt him by saying afterwards, “I’ve always wanted to sleep with a foreign man,” making him feel like an exotic pet allowed for one moment into the sitting room.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With his lips close to the grille, he gave an abridged version of these events and, in the silence that followed, felt the familiar cold breath of the chapel floor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The priest coughed behind the curtain. He said that while God understood war made many men lustful in ways they didn’t understand, Anto must now, given the particular circumstances of his life, make an extra effort to control himself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Was he mistaken, the priest asked, in thinking there was a bride waiting for him in South India? Not a bride, he’d replied, a young girl, the daughter of a family friend. He’d never met her, he said, or if he had, he couldn’t remember her: he’d come to England when he was sixteen. Well, God would forgive him, the priest had said more robustly, but only if he now made a solemn commitment to change. The war had bent everyone out of shape, he said; it was time now to return to the old certainties.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The old certainties, he thought later, back in his Oxford digs, eating the cold macaroni and cheese his landlady had left on a tray, what a luxury it would be to know what they were. For years, the idea of a God, loving or otherwise, had been slipping away from him, like a small boat unmoored and disappearing in a dark sea.")]), _vm._v(" "), _c('p', {
    staticClass: "TXB_Bottom"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "TXF"
  }, [_vm._v(" “So, this is it.” She opened a carved door at the end of the corridor and lifted her candle. “Your room.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When the lights pulsed and flickered into life, both of them jumped.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("“Thank God for that,” she said. Her smile was very pretty. “We ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("have a dreadful time with the electrics here. If you like I could give you a torch?”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Thank you,” he said. He’d smashed his own when he’d fallen off the Norton.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He looked around him. He liked his new room. With its tilted floor and cracked ceiling it was shabby for sure, but far more homely-looking than his digs in Woodstock Road. Its walls were covered in a lovely old blue Chinese wallpaper, its vines and birds a little watermarked here and there but giving it a kind of faded grandeur. The brass bed with its comfortable-looking blue eiderdown faced the window, from which he could see the dark shapes of the valley beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Is it all right?” She was watching him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s lovely.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Bedside light.” When she leaned and switched it on, the room became a cozy cave.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Washstand.” She pointed at a large jug. “Basin, towel. You must be tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No,” he said, “I’m not.” He hesitated. “Actually, I spent the afternoon in the Odeon in Oxford.” He didn’t tell her about the five a.m. start to study the pediatrics bible. One of the many disguises learned by his second term at Downside was to saunter into exams saying he didn’t know a bloody thing but what the hell?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What did you see?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He handed her his ticket. When she peered at it under the lamp, he saw she’d rolled her hair around a scarf.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Celia Johnson. "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Brief Encounter")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Damn it! I missed it! We’ve been snowed in.” She handed the ticket back. “Never mind, I’ve seen it twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘I shall never, "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("ever ")]), _vm._v("tell anyone else about us,’” he said, with Trevor Howard’s look of crushed nobility.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“‘Because all I want is to know that you are safe,’” she said.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Her laughter was velvety and deep. It showed her white teeth. “What a lot of tosh,” she said.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("“Complete pap,” he agreed, although he’d sat there, heart worn, entranced. “But it passed a pleasant few hours, and I didn’t want to arrive too early.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The last picture I saw,” she said, “was a real stinker: "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("The Steam Railways of Mid-Wales")]), _vm._v(". I thought I would die of boredom. Do you go to the cinema a lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She was standing with her hand on the door, looking at him with her direct gaze, and part of him was shocked. Why did her mother allow her to go unescorted to a man’s room? Where was everyone?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“When work allows it,” he said in a discouraging way. “You see I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Kit!” A sharp voice interrupted him. “Kit, come down here at once!”"), _c('span', {
    staticClass: "Italic"
  }), _vm._v("The screeching voice rose. “"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Where on earth are you?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I am twenty-eight years old,” she said, with a conspirator’s grin. “My mother thinks I’m two.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You must go at once.” His face was stern in the lamplight, his expression sincere. “Your mother is calling you.”")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1474eb00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch04.vue
// module id = 81
// module chunks = 0